import { memo } from 'react';
import { useTranslation } from '@bonanza-social/i18n';
import { LobbyWidget } from '@bonanza-social/moonlight';
import { useTransmitResolver } from '@bonanza-social/transmit-resolver';

function WelcomeLobbyWidget() {
  const [t] = useTranslation('onboarding');
  const { shouldTransmit, handleTransmit } = useTransmitResolver();

  if (!shouldTransmit) {
    return null;
  }

  return (
    <LobbyWidget
      image="common.Megaphone"
      label={t('widgetLabel')}
      onClick={() => handleTransmit()}
      hasUnread
      showUnreadBadge
    />
  );
}

export default memo(WelcomeLobbyWidget);
